export default [
    {
        title: '音乐库管理',
        path: '/musicLibrary',
        name: 'musicLibrary',
        meta: {
            key: 'musicLibrary',
            open: 'musicLibrary'
        },
        permission: 'musicLibrary',
        menu: true,
        component: () => import('@/views/musicLibrary/list')
    },
    {
        title: '音乐表单',
        path: '/musicLibrary/form',
        name: 'musicLibraryForm',
        meta: {
            key: 'musicLibrary',
            open: 'musicLibrary'
        },
        permission: false,
        menu: false,
        component: () => import('@/views/musicLibrary/form')
    }
];
